

define(['angular', 'squid/index', 'text!./template.html', 'xo-models/src/checkout/index'], function (angular, squid, template) {
    squid.module('xo-faq.directive', ['squid', 'xomodel.checkout']).directive('xoFaq', function () {
        return {
            template: template
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/choose-credit-offer/faq/directive.js
// module id = ../node_modules/xo-credit-components/src/choose-credit-offer/faq/directive.js
// module chunks = 0